var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleDesktopPlace = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 12,
  viewBox: "0 0 8 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4 0a4 4 0 0 1 4 4c0 .334-.215 1.536-.538 2.124-.77 1.403-2.154 2.692-2.685 3.926-.72 1.67.184 1.45-.777 1.45h-.096c-.8.01.044.105-.646-1.47C2.716 8.793 1.34 7.6.56 6.18.225 5.57 0 4.345 0 4a4 4 0 0 1 4-4m.047 2.2-.747.9-1 .3.724 1.8H5l.7-1.766-.9-.234z"
})));
export default SvgGoogleDesktopPlace;